import { render, staticRenderFns } from "./b1.vue?vue&type=template&id=70956290"
import script from "./b1.vue?vue&type=script&lang=js"
export * from "./b1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports